import AppDataService from "./AppDataService";

export default class TemplateService {
  static async getTemplatesByType(type, params = {}) {
    const errLabel = type === "Email" ? "email" : "SMS";
    try {
      const queryParams = [
        params?.pageNumber >= 0 ? `pageNumber=${params.pageNumber}` : "",
        params?.limit ? `limit=${params.limit}` : "",
        `type=${type}`,
      ]
        .filter(Boolean)
        .join("&");

      const queryString = queryParams ? `?${queryParams}` : "";
      const { data: response } = await AppDataService.get(
        `admin/template${queryString}`
      );

      if (response.success && response.templates) {
        return {
          success: true,
          templates: response.templates.map((template) => ({
            label: template.name,
            value: template.id,
            ...template,
          })),
        };
      }

      return {
        success: false,
        templates: [],
        error: response.message || `Failed to fetch ${errLabel} templates`,
      };
    } catch (error) {
      console.error(`Error fetching ${errLabel} templates:`, error);
      return {
        success: false,
        templates: [],
        error: error.message || `Failed to fetch ${errLabel} templates`,
      };
    }
  }

  static getEmailTemplates(params = {}) {
    return this.getTemplatesByType("Email", params);
  }

  static getSmsTemplates(params = {}) {
    return this.getTemplatesByType("Message", params);
  }
}
